import { render, staticRenderFns } from "./ShippingRateRegionTable.vue?vue&type=template&id=68be5482&scoped=true"
import script from "./ShippingRateRegionTable.vue?vue&type=script&lang=js"
export * from "./ShippingRateRegionTable.vue?vue&type=script&lang=js"
import style0 from "./ShippingRateRegionTable.vue?vue&type=style&index=0&id=68be5482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be5482",
  null
  
)

export default component.exports